import React from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
} from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphFaqItems = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const faqItems = entity.getIn(['field_faq_items']);

  return (
    <Container className="ParagraphFaqItems">
      <div className="row">
        <div className="ParagraphFaqItems__inner col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
          {title && (
            <h2>{title}</h2>
          )}

          {body && (
            <WysiwygField
              property="schema:text"
              className="ParagraphFaqItems__body"
              html={body}
            />
          )}

          {faqItems.map((faq) => {
            const faqEntity = faq.get('entity');
            if (!faqEntity) {
              return null;
            }
            const faqNid = faqEntity.getIn(['nid', 0, 'value']);
            return (
              <Node key={faqNid} id={faqNid} entity={faqEntity} />
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphFaqItems;
